module.exports = __webpack_public_path__ + "img/20190613162243655.3e96583f.png";